<template>
  <div class="page">
		<PageHeader>
			Кошельки
		</PageHeader>

		<div class="content" v-if="loaded">
			<div class="block" style="max-width: 500px" v-if="session.type === 1">
				<div class="header">
					<div class="close delete" v-if="wallet._id" @click.prevent="cancelEditWallet()">Отменить</div>
					<div class="title">{{ wallet._id ? 'Редактировать кошелек' : 'Добавить кошелёк'}}</div>
				</div>
				<div class="content">
						<input type="text" placeholder="Название" v-model="wallet.title" />
						<!-- <input type="number" placeholder="Баланс" v-model="wallet.balance" /> -->
						<!--  -->
						<p>Валюта:</p>
						<select v-model="wallet.valuteId">
							<option value="" disabled>Не выбрано</option>
							<option v-for="valute in valutes" :key="valute._id" :value="valute._id">{{ valute.title }}</option>
						</select>
					</form>
				</div>
			</div>

			<div class="block" style="max-width: 500px" v-if="session.type === 1">
				<div class="header">
					<div class="title">Формы кошелька:</div>
				</div>
				<div class="content">
					<form @submit.prevent="SubmitForm()">
						<input type="text" placeholder="Название" v-model="activeForm.title" />
						<input type="text" placeholder="Описание" v-model="activeForm.description" />
						<button>{{ this.activeFormIndex < 0 ? 'Сохранить' : 'Добавить' }}</button>
					</form>
					<!--  -->
					<p v-if="walletForms && walletForms.length">Формы:</p>
					<p v-else>Список форм пуст.</p>
					<ul style="padding-left: 20px">
						<li v-for="(form, index) in walletForms" :key="index" style="border-bottom: 1px solid #d9d9d9;margin-bottom: 5px;">
							<p class="delete" style="float: right;" @click.prevent="RemoveWalletForm(index, form)">Удалить </p>
							<p class="edit" style="float: right; margin-right: 5px;" @click.prevent="EditWalletForm(index, form)">Ред. </p>
							<p>{{ form.title }} : {{ form.description }}</p>
						</li>
					</ul>
					<!--  -->
				</div>
			</div>

			<button v-if="session.type === 1" @click.prevent="SubmitWallet()">{{ this.wallet._id ? 'Редактировать кошелёк' : 'Добавить кошелёк' }}</button>

			<br /><h4>Кошельки:</h4><br />

			<div class="block" style="max-width: 500px" v-for="wallet in wallets" v-if="wallets && walletForms">
				<div class="header">
					<div class="close delete" v-if="session.type === 1" @click.prevent="RemoveWallet(wallet)">Удалить</div>
					<div class="close edit" v-if="session.type === 1" @click.prevent="EditWallet(wallet)">Редактировать</div>
					<div class="title">{{ wallet.title }}</div>
				</div>
				<div class="content" style="overflow: auto">
					<p v-if="walletsForms[wallet._id] && walletsForms[wallet._id].length">Формы:</p>
					<p v-else>Нет форм</p>
					<ul
						style="padding-left: 20px"
						v-if="walletsForms[wallet._id] && walletsForms[wallet._id].length"
					 	>
						<li
							v-for="form in walletsForms[wallet._id]"
							v-if="walletsForms[wallet._id] && walletsForms[wallet._id].length && form._id"
							>{{ form.title }} : {{ form.description }}</li>
					</ul>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageHeader from "../../ui/PageHeader.vue";
//
export default {
  components: { PageHeader },
  name: 'Main',

	data: () => ({
		loaded: false,

		wallet: {
			_id: false,
			title: '',
			balance: 0,
			valuteId: '',
		},

		walletForms: [],

		activeFormIndex: -1,
		activeForm: {
			_id: false,
			title: '',
			description: '',
		}
	}),

	computed: {
		...mapState('auth', ['session']),
		...mapState('wallets', ['wallets', 'walletsForms']),
		...mapState('valutes', ['valutes']),
	},

	methods: {
		...mapActions('wallets', [
			'getWallets',
			'addWallet',
			'editWallet',
			'deleteWallet',
			'addWalletForm',
			'editWalletForm',
			'deleteWalletForm'
		]),
		...mapActions('valutes', ['getValutes']),

		CancelEditWallet () {
			this.wallet = {
				_id: false,
				title: '',
				balance: '',
				valuteId: '',
			}
			//
			this.walletForms = []
			//
			this.activeForm = { _id: false, title: '', description: '' }
		},

		RemoveWallet (wallet) {
			let accept = confirm('Удалить кошелёк?')
			if (accept) {
				this.deleteWallet(wallet._id)
					.then(() => this.$nextTick())
					.then(() => alert('Успешно!'))
			}
		},

		EditWallet (wallet) {
			this.wallet = {
				_id: wallet._id,
				title: wallet.title,
				balance: wallet.balance,
				valuteId: wallet.valute._id,
			}
			this.walletForms = this.walletsForms[wallet._id]
		},

		RemoveWalletForm (index, form) {
			if (form._id) {
				this.deleteWalletForm({ id: form.walletId, formId: form._id })
					.then(() => alert('Успешно!'))
			}
			//
			this.walletForms.splice(index, 1)
		},

		EditWalletForm (index, form) {
			this.activeFormIndex = index
			this.activeForm = form
		},

		SubmitWallet () {
			const wallet = this.wallet
			const forms = this.walletForms
			//
			if (wallet._id) {
				this.editWallet({ id: wallet._id, wallet })
					.then(() => this.$nextTick())
				//
				Promise.all(forms.map(form => {
					if (form._id) {
						return this.editWalletForm({ id: wallet._id, formId: form._id, form })
					} else {
						return this.addWalletForm({ id: wallet._id, form })
					}
				}))
					.then(() => this.$nextTick())
					.then(() => alert('Успешно!'))
					.then(this.CancelEditWallet())
			} else {
				this.addWallet(wallet)
					.then(response => {
						return Promise.all(forms.map(form => {
							return this.addWalletForm({ id: response.data.result._id, form })
						}))
					})
					.then(() => this.$nextTick())
					.then(() => alert('Успешно!'))
					.then(this.CancelEditWallet())
			}
		},

		SubmitForm () {
			this.walletForms.push(this.activeForm)
			//
			this.activeFormIndex = -1
			this.activeForm = { _id: false, title: '', description: '' }
		}
	},

	mounted () {
		Promise.all([
			this.getWallets(),
			this.getValutes(),
		])
			.then(() => {
				this.loaded = true
				//
				setTimeout(() => this.$forceUpdate(), 500)
			})
	}
}
</script>

<style scoped>
.delete {
	color: red;
}

.edit {
	color: orange;
}

.delete:hover, .edit:hover {
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Wallets/index.vue